import { colors } from "../../Styles";

export function Edit({size = "20px", fillColor = colors.greyLightTertiary}) {
  return (
    <svg height={size} width={size} fill={fillColor} xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 283.46 283.46">
      <g transform="matrix(1,0,0,1,3.64575,2.82884)">
          <path d="M98.77,139.12L233.79,9.96C236.63,7.25 240.83,7.03 243.18,9.49L261.67,28.82C264.02,31.27 263.62,35.46 260.78,38.18L125.76,167.33L77.77,186.22L98.77,139.12Z" style={{fillRule: "nonzero", stroke: fillColor, strokeWidth: "5.36px"}}/>
      </g>
      <g transform="matrix(1,0,0,1,3.64575,2.82884)">
          <path d="M147,39L40.39,39C40.39,39 25.565,38.438 22,42C18.435,45.562 19,60.37 19,60.37L19,243C19,243 18.435,257.5 22,261C25.565,264.5 40.39,264 40.39,264L188.48,264C188.48,264 203.413,264.5 207,261C210.587,257.5 210,243 210,243L210,134" style={{fill: "none", stroke: fillColor, strokeWidth: "18px", strokeLinecap: "square", strokeLinejoin: "round", strokeMiterlimit: "1.5"}}/>
      </g>
    </svg>
  );
}